var EDS = {
  enabled: true,
  automateWebEvent: 'automate_web_events',
  liveWebEvents: 'live_web_events',
  appLiveWebEvents: 'app_live_web_events',
  webEvents: 'web_events',
  webEventsPii: 'web_events_pii',
  user: {},
  init: function (userDetails) {
    EDS.user = userDetails;
    EDS.enabled = true;
  },

  getHeader: function (eventName) {
    switch (eventName) {
      case 'WordpressPerformanceStats':
        return {
          name: 'X-Wordpress-Performance-Stats',
          val: 'performance',
        };
      default:
        return false;
    }
  },

  getAmplitudeSpecificData: function () {
    var bsDeviceId = EDS.getBsDeviceId(),
    demographics = EDS.getUserDemographics();
    
    return {
      device_id: bsDeviceId,
      group_id: Cookie.read('bs_group_id') || '',
      user_id: Cookie.read('bs_logging_id') || '',
      city: EDS.user['location']['city'],
      country: EDS.user['location']['country'],
      ip: EDS.user['location']['ip'],
      region: EDS.user['location']['region'],
      location_lng: EDS.user['location']['longitude'],
      location_lat: EDS.user['location']['latitude'],
      device_family: demographics['os'],
      device_model: demographics['os'],
      device_type: demographics['os'],
      os: demographics['os'],
      os_name: demographics['os'],
      os_version: demographics['os'],
      browser: demographics['browser'],
      browser_version: demographics['browser_version'],
      platform: demographics['platform'],
      timezone: bsLib.getTimeZone(),
      timezone_loc: bsLib.getTimeZoneLocation()
    };
  },

  logEvent: function (eventName, eventType, extraData, sessionId, sendToBeacon) {
    if (!EDS.enabled) return;
    
    //check bsLib object length
    if (Object.keys(bsLib).length === 0) return;

    EDS.user = bsLib.extend(EDS.user, EDS.getAmplitudeSpecificData());
    EDS.user = bsLib.extend(EDS.user, {
      vwo: Amplitude.getVWOExperiments(),
    });

    //For adding user A/B exp details in EDS
    EDS.user = bsLib.extend(EDS.user, {
      internalAbExps: Amplitude.getInternalABExperiments(),
    });

    // check query param for lighthouse url
    var checkLightHouseUrl = bsLib.getParameterByName('isLightHouse', document.location.href);
    if (checkLightHouseUrl === 'true') {
      EDS.user = bsLib.extend(EDS.user, {
        isLightHouse: true,
      });
    }

    /*
     * @To-Do Remove url, referrer and referrerHostname from here and Amplitude file. move this values to Webtracker file.
     */
    var eventData = {
      event_type: eventType,
      data: bsLib.extend(
        {},
        {
          user: EDS.user,
          event_name: eventName,
          session_id: sessionId,
          team: 'wordpress',
          url: [location.protocol, '//', location.host, location.pathname].join(''),
          referrer: document.referrer,
          referrerHostname: document.referrer.split('/')[2],
          userAgent: navigator.userAgent,
        },
        extraData
      ),
      api_key: EdsConfig.api,
    };

    var edsURL = 'https://' + EdsConfig.server + ':' + EdsConfig.port + '/send_event';

    if (sendToBeacon && navigator && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(
        edsURL, 
        JSON.stringify(eventData)
      );
    } else {
      bsLib.ajax(
        'POST',
        edsURL,
        JSON.stringify(eventData),
        true, //async
        { 'Content-Type': 'application/json' }, //request header
        function () {}, //success
        function () {}, //error object
        true
      );
    }
  },

  guid: function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  },

  getUserDemographics: function () {
    var browserAndVersion = EDS.getBrowserVersion();
    var browser = browserAndVersion[0];
    var browser_version = browserAndVersion[1];
    var demographics = {
      os: EDS.getUserOS(),
      browser: browser,
      browser_version: browser_version,
      platform: EDS.getPlatform(),
    };

    return demographics;
  },

  getUserOS: function () {
    var OSName = 'Unknown OS';
    if (navigator.appVersion.indexOf('Win') != -1) OSName = 'Windows';
    if (navigator.appVersion.indexOf('Mac') != -1) OSName = 'Mac';
    if (navigator.appVersion.indexOf('X11') != -1) OSName = 'UNIX';
    if (navigator.appVersion.indexOf('Linux') != -1) OSName = 'Linux';

    return OSName;
  },

  getBrowserVersion: function () {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M;
  },

  getPlatform: function () {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return 'Mobile';
    } else {
      return 'Web';
    }
  },

  getBsDeviceId: function() {
    var bsDeviceId = Cookie.read('bs_deviceId');
    if (bsDeviceId == undefined || bsDeviceId == 'undefined' || bsDeviceId == '') {
      bsDeviceId = EDS.guid();
      Cookie.create('bs_deviceId', bsDeviceId);
    }
    return bsDeviceId;
  }
};
